// import {cartSampleTemplate} from '../templates';
var CartSampleView = Backbone.View.extend({
    tagName: 'div',
    className: 'cart-product',
    events: {
        'click a.remove-product': 'removeFromCart',
        'change input.qty': 'updateQuantity'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'removeFromCart', 'updateQuantity' );
        this.template = _.template(document.getElementById('cart-sample-template').innerHTML );
        // this.listenTo( this.model, 'change', this.render );
    },
    render: function(){
        var html = this.template( this.model.toJSON() );
        this.$el.html( html );
    },
    updateQuantity: function( e ) {
        var x = e.target
        if ( /^\d*$/.test( x.value ) ) {
            // only update if it is a number
            this.model.set({'quantity' : x.value });
        } else{
            x.value = this.model.get('quantity');
        }
    },
    removeFromCart: function( e ){
        e.preventDefault();
        //window.cart.sendMessage( 'Removing Sample' );
        this.model.destroy();
        this.remove();
    }
});
export {CartSampleView};